
/**
 * Configuration
 *
 * @namespace vamos.cockpit.config
 */
export default class Config {
    LoginUrl: string = "/login/index.html";
    BackendUrl: string = "/VamosCore";
    BackendRestUrl: string = "/VamosCore/service/";
    ODataUrl: string = "/VamosCore/service/private/odata.svc/";
    CiamProfilePage: string = "";

    private static envOverrides: Partial<Config> = {};

    constructor() {
        Object.assign(this, Config.envOverrides);
    }

    /**
     * Fetches overrides from env-config.json, a static file generated at build/serve time
     * from .env (see scripts/generate-env-config.js), and caches them statically so every
     * Config instance created afterwards (Config is instantiated ad hoc throughout the app,
     * not just once) picks them up via the constructor. Must be awaited once at app startup
     * before the first Config instance is created. Missing/unreachable env-config.json is not
     * an error - the defaults above simply apply.
     */
    public static async loadEnvConfig(): Promise<void> {
        try {
            const url = sap.ui.require.toUrl("vamos/cockpit/config/env-config.json");
            const response = await fetch(url);
            if (!response.ok) {
                return;
            }
            Config.envOverrides = await response.json() as Partial<Config>;
        } catch {
            // env-config.json not generated for this environment - keep defaults
        }
    }

    public static getConfigValue(pKey: string) {
        return new Config().getValue(pKey);
    }
    public getValue(p_sKey: string) {
        switch (p_sKey) {
            case "BackendRestUrl":
                return this.BackendRestUrl;
            case "LoginUrl":
                return this.LoginUrl;
            case "BackendUrl":
                return this.BackendUrl;
            case "ODataUrl":
                return this.ODataUrl;
            case "CiamProfilePage":
                return this.CiamProfilePage;
            default:
                return "";
        }
    }

    private getUrlWithBacklash(p_url: string): string {
        return p_url.slice(-1) !== "/" ? p_url + "/" : p_url;
    }

    public getRestUrl(p_pathParam: string, p_isPublic: boolean = false): string {
        const accessLevel: string = p_isPublic ? "public" : "private";
        let url: string = this.getUrlWithBacklash(this.getValue("BackendRestUrl") as string);

        url = url + accessLevel;

        if (Array.from(p_pathParam)[0] !== "/") {
            url = url + "/";
        }
        url = url + p_pathParam;
        return url;
    }
}
